import * as React from "react"

function App() {
    return (
    <>

        {/* Page HTML */}

        <main id='king-home'>

            <div id="deviceRotated">
                <span>
                    <img src="assets/images/deviceRotated.svg" />
                    Rota tu dispositivo.
                </span>
            </div>

            <div className='loader'>
                    <span className='loader-logo'></span>
                    <div className='loader-load'>
                        <span className='loader-load-bar'> <span></span> </span>
                        <span className='loader-load-value'>0%</span>
                    </div>
                    <div className='loader-button'>Entrar al museo</div>
            </div>

            <div className='UI_cont'>
                <div className='UI-button UI-help'></div>
                <div className='UI-button UI-sound disabled'></div>
            </div>

            <div className='help'>
                <div className='help-cont'>
                    <div className='UI-button help-close'></div>
                    <section>
                        <h2 className='help-title'>Explora<br />tu entorno</h2>

                        <div className='help-item'>
                            <img src="assets/images/inst-01.png" />
                            <p><b>Desplázate</b>tocando el suelo.</p>
                        </div>
                        <div className='help-item'>
                            <img src="assets/images/inst-02.svg" />
                            <p><b>Observa alrededor</b>haciendo clic y arrastrando </p>
                        </div>
                        <div className='help-item'>
                            <img src="assets/images/inst-03.png" />
                            <p><b>Interactúa</b>con los botones.</p>
                        </div>
                    </section>
                </div>
            </div>

            <canvas id='canvas-home'></canvas>

        </main>

    </>
    )
}

export default App
